import { all } from 'redux-saga/effects';

import historyWatcher from './salary-history-saga';

export default function* rootSaga(action) {
	yield all([historyWatcher(action)]);
}
